import { Box, Stack } from '@mui/material'
import logoAlume from '@/assets/images/logo-alume.svg'
import { HiringStepper } from './hiring-stepper'
import { matchPath, useLocation } from 'react-router-dom'
import { routes } from '@/router'
export const HiringHeader = () => {
  const location = useLocation()

  const isHiddenStepper = [
    routes.accounting.hiring.contract,
    routes.accounting.hiring.proposal,
    routes.accounting.hiring.preContract,
  ].some((route) => matchPath(route, location.pathname))

  const isContractPage = Boolean(
    matchPath(routes.accounting.hiring.contract, location.pathname),
  )

  return isContractPage ? null : (
    <Stack
      flexDirection={'column'}
      alignItems="center"
      justifyContent={{ md: 'space-between' }}
      mt={4}
      mb={4}
    >
      <Box component={'img'} alt={'Logo Alume'} src={logoAlume} />

      {!isHiddenStepper && <HiringStepper />}
    </Stack>
  )
}
